import React, { useEffect, useRef } from 'react'
import PageHeading from '../components/common/PageHeading'
import SectionTitle from '../components/common/SectionTitle'
import CoursesCard from '../components/common/CoursesCard'
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet';

function ProgramsAndCourses() {

    const section1 = useRef(null);
    const section2 = useRef(null);
    const section3 = useRef(null);

    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const section = params.get('section');

        if (section === 'preSchool') {
            section1.current.scrollIntoView();
        } else if (section === 'oxfordCollege') {
            section2.current.scrollIntoView();
        } else if (section === 'englishQualification') {
            section3.current.scrollIntoView();
        }
    }, [location]);

    const enrollNowHandler = () => {
        window.location.href = '/admission-form'
    }

    const preschool = [
        {
            title: 'Play Group',
            alignment: 'right',
            description: 'Our Play Group program provides a nurturing and joyful environment where young children begin their educational journey. Through play-based learning and engaging activities, we focus on developing social skills, fine motor abilities, and a curiosity for the world around them. This early experience fosters confidence, creativity, and a love for learning that forms a strong foundation for future academic success.',
            imageUrl: './assets/images/PG.webp',
            alt: 'Play Group Image'
        },
        {
            title: 'Lower Kindergarten (LKG)',
            alignment: 'left',
            description: 'In Lower Kindergarten, we build on the foundations of early childhood education with a structured program that balances learning and play. Our curriculum emphasizes language development, early numeracy, and interactive activities that encourage cognitive growth. Through hands-on exploration and creative expression, children in LKG develop essential skills that prepare them for the next stage of their academic journey.',
            imageUrl: './assets/images/LKG.webp',

            alt: 'Nursery Image'
        },
        {
            title: 'Upper Kindergarten (UKG)',
            alignment: 'right',
            description: 'Upper Kindergarten at Oxford College Gampaha focuses on preparing children for primary school with a well-rounded curriculum that nurtures literacy, numeracy, and social skills. Our UKG program enhances critical thinking and problem-solving abilities, while promoting independence and self-confidence. This final stage of early childhood education ensures that students are equipped with the skills they need for a smooth transition into formal schooling.',
            imageUrl: './assets/images/UKG.webp',
            alt: 'Kindergarten Image'
        }
    ]

    const englishCourses = [
        {
            title: 'Kids Plus',
            alignment: 'right',
            description: 'Our Play Group program provides a nurturing and joyful environment where young children begin their educational journey. Through play-based learning and engaging activities, we focus on developing social skills, fine motor abilities, and a curiosity for the world around them. This early experience fosters confidence, creativity, and a love for learning that forms a strong foundation for future academic success.',
            imageUrl: './assets/images/card-img-kidsplus.webp',
            alt: 'General English Image'
        },
        {
            title: 'Primary Plus',
            alignment: 'left',
            description: 'Primary Plus is a lively English course aimed at primary school students, focusing on developing essential language skills such as reading, writing, speaking, and listening. Using a blend of creative activities, storytelling, and collaborative projects, this program encourages curiosity and builds confidence in English. Primary Plus is designed to make learning English enjoyable and effective, ensuring students can express themselves clearly and understand basic conversations.',
            imageUrl: './assets/images/card-img-primaryplus.webp',
            alt: 'Business English Image'
        },
        {
            title: 'Junior Plus',
            alignment: 'right',
            description: 'Junior Plus is an in-depth English course tailored for junior-level students, helping them expand their vocabulary, improve grammar, and enhance fluency in both spoken and written English. This course emphasizes critical thinking and communication skills through interactive discussions, role-playing, and group activities. Junior Plus prepares students for more advanced English studies by fostering an environment where they can express their ideas creatively and confidently.',
            imageUrl: './assets/images/card-img-juniorplus.webp',
            alt: 'Exam Preparation Image'
        },
        {
            title: 'Senior Plus',
            alignment: 'left',
            description: 'Senior Plus is an advanced English program designed to prepare senior students for academic and professional communication in English. This course focuses on refining language skills, with a strong emphasis on analytical reading, persuasive writing, and articulate speaking. Students engage in discussions, debates, and presentations, which help develop critical thinking and effective communication skills essential for higher education and future careers. Senior Plus equips students with the language proficiency needed to succeed in diverse environments.',
            imageUrl: './assets/images/card-img-seniorplus.webp',
            alt: 'Exam Preparation Image'
        }
    ]

    const cambridgeEnglishCourses = [
        {
            title: 'Pre A1 : Starters (Young Learners)',
            alignment: 'right',
            description: 'The Starters course is the perfect introduction to English for young learners. Designed for children at the beginning of their language journey, this program covers basic vocabulary, simple sentence structures, and everyday expressions. Through fun activities, songs, and games, students build confidence in listening, speaking, and recognizing basic English words. Starters sets a solid foundation in English, making the first steps into language learning enjoyable and engaging.',
            imageUrl: './assets/images/card-img-starters.webp',
            alt: 'Exam Preparation Image'
        }, {
            title: 'A1 : Movers (Young Learners)',
            alignment: 'left',
            description: 'Movers is the next step for young learners who have completed the basics and are ready to expand their English skills. This course introduces students to new vocabulary and simple grammar, helping them understand and use familiar expressions in short conversations. Movers focuses on building listening, speaking, reading, and writing abilities through interactive exercises and group activities. By the end of the course, students are prepared to handle simple everyday communication in English.',
            imageUrl: './assets/images/card-img-movers.webp',
            alt: 'Exam Preparation Image'
        }, {
            title: 'A2 : Flyers (Young Learners)',
            alignment: 'right',
            description: 'Flyers is an intermediate-level course for young learners who are progressing well in English. This course builds on the foundation laid in Starters and Movers, introducing students to more complex vocabulary, sentence structures, and reading comprehension. Through engaging exercises and practical activities, Flyers helps students communicate more fluently and accurately, preparing them to handle real-life situations and transition smoothly to higher-level English studies.',
            imageUrl: './assets/images/card-img-flyers.webp',
            alt: 'Exam Preparation Image'
        },
        {
            title: 'A2 : KET (Key English Test)',
            alignment: 'left',
            description: 'KET is a beginner-level English course ideal for students who want to establish a strong foundation in practical language skills. The course focuses on basic speaking, listening, reading, and writing skills needed for everyday situations. Through role-plays, dialogues, and comprehension exercises, students learn to express themselves in simple English and develop the confidence to communicate in real-life contexts. KET is the perfect course for learners aiming to start their English language journey with a focus on practical usage.',
            imageUrl: './assets/images/card-img-ket.webp',
            alt: 'Exam Preparation Image'
        },
        {
            title: 'B1 : PET (Preliminary English Test)',
            alignment: 'right',
            description: 'PET is an intermediate English course designed to improve students&apos; ability to communicate effectively in various everyday scenarios. This course covers essential grammar, vocabulary, and conversational skills that help students understand and participate in basic interactions. PET emphasizes reading comprehension, structured writing, and spoken fluency, giving students the confidence to use English in both social and work-related contexts. It&apos;s an ideal course for those looking to deepen their practical language abilities.',
            imageUrl: './assets/images/card-img-pet.webp',
            alt: 'Exam Preparation Image'
        },
        {
            title: 'B2 : FCE (First Certificate in English)',
            alignment: 'left',
            description: 'FCE is an upper-intermediate English course that equips students with the language skills needed for academic and professional settings. The course covers complex grammar, advanced vocabulary, and a range of reading, writing, listening, and speaking activities. FCE helps students communicate clearly and confidently on a variety of topics, making it an ideal choice for learners preparing for university studies or looking to improve their job prospects. By the end of the course, students will be well-prepared for everyday life in an English-speaking environment.',
            imageUrl: './assets/images/card-img-fce.webp',
            alt: 'Exam Preparation Image'
        },
        {
            title: 'C1 : CAE (Cambridge Advanced Certificate in English)',
            alignment: 'right',
            description: 'CAE is an advanced English course aimed at students who want to reach a high level of proficiency. This rigorous program prepares learners to use English effectively in demanding academic and professional settings. The course focuses on advanced grammar, sophisticated vocabulary, and complex reading and writing tasks, as well as fluent, confident speaking. CAE is ideal for students aspiring to study at an English-speaking university, work in international settings, or achieve a professional level of English.',
            imageUrl: './assets/images/card-img-cae.webp',
            alt: 'Exam Preparation Image'
        },
    ]

    return (
        <div className="flex flex-col min-h-screen">
            <Helmet>
                <title>Programs and Courses - Oxford College</title>
                <meta name="description" content="Discover the diverse range of programs and courses offered by Oxford College." />
                <meta name="keywords" content="Programs, Courses, Education, Oxford College, Learning" />
                <meta name="author" content="Oxford College - Gampaha" />
                <meta property="og:title" content="Programs and Courses - Oxford College - Gampaha" />
                <meta property="og:description" content="Explore the variety of programs and courses available at Oxford College." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://oxfordcollege.lk/programs-and-courses" />
                <meta property="og:image" content="https://www.facebook.com/photo/?fbid=127196623392555&set=a.127196626725888" />
            </Helmet>

            <PageHeading
                imgUrl='./assets/images/programsancourses.webp'
                alt='programs and courses'
                title='Programs and Courses'
            />

            <section className='mt-8 md:mt-12 lg:mt-0 px-4 md:px-6 lg:container mx-auto'>
                {/* <SectionTitle
                    titleText='Academics at Oxford College'
                    textAlignment='center'
                /> */}

                <div
                    className='mt-8 lg:mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-20 items-start lg:place-items-end'>
                    {/* Text Content */}
                    <div className='space-y-6'>
                        <p className='text-justify sm:text-left leading-relaxed'>
                            At Oxford College Gampaha, our academic programs are designed to cultivate knowledge,
                            critical thinking, and a passion for learning. With a strong foundation in the Cambridge
                            English curriculum, our students benefit from a rigorous, globally recognized framework that
                            prepares them for academic success and beyond. Our dedicated faculty members bring expertise
                            and enthusiasm to each classroom, ensuring that students from ages 4 to 18 receive
                            personalized guidance and support.
                        </p>
                        <p className='leading-relaxed'>
                            Through an engaging and comprehensive curriculum, we empower students to excel across a
                            variety of subjects, while fostering skills in communication, creativity, and analytical
                            reasoning. Whether building foundational language skills or preparing for higher education,
                            our programs inspire students to become confident, lifelong learners ready to make a
                            meaningful impact in a rapidly changing world.
                        </p>
                    </div>

                    {/* Image Section */}
                    <div
                        className="relative h-[300px] sm:h-[340px] lg:h-[380px] w-full rounded-xl overflow-hidden mt-8 lg:mt-0">
                        {/* Background Div */}
                        <div className="absolute flex items-center justify-end pe-5 inset-0 bg-primary-blue text-white"
                            style={{ height: 'calc(100% - 60px)', top: '60px' }}>
                            <h2 className='text-end font-bebas text-4xl lg:text-5xl md:text-6xl px-4 sm:px-8s max-w-[calc(100%/2)] w-full lg:text-end xl:text-5xl'>
                                Excellence in Academics
                            </h2>
                        </div>

                        {/* Image */}
                        <img
                            src="./assets/images/girl_holding_a_book.webp"
                            alt="Programs and courses"
                            className="absolute inset-0 w-auto scale-125 h-full object-cover z-10 md:left-32 lg:left-4"
                        />
                    </div>
                </div>
            </section>

            <section className='mt-16 container mx-auto px-4 md:px-6 lg:px-0' ref={section1}>
                <SectionTitle titleText='Oxford International Pre School' textAlignment='center' />
                {/* Courses */}
                <div className='grid gap-8 lg:gap-20 mt-8 lg:mt-12'>
                    {preschool.map((course, index) => (
                        <CoursesCard
                            key={index}
                            enrollHandler={enrollNowHandler}
                            title={course.title}
                            description={course.description}
                            imageUrl={course.imageUrl}
                            alt={course.alt}
                            alignment={course.alignment}
                        />
                    ))}
                </div>
            </section>
            <section className='mt-16 max-h-[500px] overflow-hidden flex items-center justify-center'>
                <img src="./assets/images/programs-banner.png" className='w-full h-full' alt="" />
            </section>
            <section className='mt-16 container mx-auto px-4 md:px-6 lg:px-0' ref={section2}>
                <SectionTitle titleText='Oxford College' textAlignment='center' />
                {/* Courses */}
                <div className='grid gap-8 lg:gap-20 mt-8 lg:mt-12'>
                    {englishCourses.map((course, index) => (
                        <CoursesCard
                            key={index}
                            enrollHandler={enrollNowHandler}
                            title={course.title}
                            description={course.description}
                            imageUrl={course.imageUrl}
                            alt={course.alt}
                            alignment={course.alignment}
                        />
                    ))}
                </div>
            </section>

            <section className='mt-16 container mx-auto px-4 md:px-6 lg:px-0' ref={section3}>
                <SectionTitle titleText='Cambridge English Qualification' textAlignment='center' />
                {/* Courses */}
                <div className='grid gap-8 lg:gap-20 mt-8 lg:mt-12'>
                    {cambridgeEnglishCourses.map((course, index) => (
                        <CoursesCard
                            key={index}
                            enrollHandler={enrollNowHandler}
                            title={course.title}
                            description={course.description}
                            imageUrl={course.imageUrl}
                            alt={course.alt}
                            alignment={course.alignment}
                        />
                    ))}
                </div>
            </section>
        </div>
    )
}

export default ProgramsAndCourses